import { render, staticRenderFns } from "./ProductPhotoAssignment.vue?vue&type=template&id=aec37c96&"
import script from "./ProductPhotoAssignment.vue?vue&type=script&lang=js&"
export * from "./ProductPhotoAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports